'use strict';

// Directive that enables iCheck on elements, courtesy of:
// https://github.com/fronteed/iCheck/issues/62
angular.module('ClinicApp').directive('icheck', function($timeout) {
  return {
    require: 'ngModel',
    link: function($scope, element, $attrs, ngModel) {
      return $timeout(function() {
        var value = $attrs.value;
        var iEl = $(element);

        $scope.$watch($attrs.ngModel, function() {
          iEl.iCheck('update');
        });

        return iEl.iCheck({
          checkboxClass: 'icheckbox_square-green',
          radioClass: 'icheckbox_square-green',
        }).on('ifChanged', function(event) {
          if (iEl.attr('type') === 'checkbox' && $attrs.ngModel) {
            return $scope.$apply(function() {
              return ngModel.$setViewValue(event.target.checked);
            });
          }
          if (iEl.attr('type') === 'radio' && $attrs.ngModel) {
            return $scope.$apply(function() {
              return ngModel.$setViewValue(value);
            });
          }
        });
      });
    },
  };
});
